import { OrderingComponent } from './ordering.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OrderingComponent });
